export const userPanel = [
  {
    id: 1,
    icon: require("../../../image/fantasysports/up-img-one.webp"),
    title: "User Registration/Login",
    description: "Easy login via email, phone, or social media",
  },
  {
    id: 2,
    icon: require("../../../image/fantasysports/up-img-two.webp"),
    title: "Home Dashboard",
    description: "Match schedules, contests, news, and team creation",
  },
  {
    id: 3,
    icon: require("../../../image/fantasysports/up-img-three.webp"),
    title: "Player Stats",
    description: "Real-time player performance and data",
  },
  {
    id: 4,
    icon: require("../../../image/fantasysports/up-img-four.webp"),
    title: "Create/Join Contests",
    description: "Public, private, and custom contests",
  },
  {
    id: 5,
    icon: require("../../../image/fantasysports/up-img-five.webp"),
    title: "Team Management",
    description: "Pick players, manage captain/vice-captain",
  },
  {
    id: 6,
    icon: require("../../../image/fantasysports/up-img-six.webp"),
    title: "Wallet System",
    description: "Secure deposits, withdrawals, transaction history",
  },
  {
    id: 7,
    icon: require("../../../image/fantasysports/up-img-seven.webp"),
    title: "Leaderboards",
    description: "Track rank and performance",
  },
  {
    id: 8,
    icon: require("../../../image/fantasysports/up-img-eight.webp"),
    title: "Push Notifications",
    description: "Alerts for contests, updates, and rewards",
  },
];

export const adminPanel = [
  {
    id: 1,
    icon: require("../../../image/fantasysports/ad-img-one.webp"),
    title: "User Management",
    description: "Control over registrations, reports, bans",
  },
  {
    id: 2,
    icon: require("../../../image/fantasysports/ad-img-two.webp"),
    title: "Match Management",
    description: "Schedule matches, set rules, scoring",
  },
  {
    id: 3,
    icon: require("../../../image/fantasysports/ad-img-three.webp"),
    title: "Contest Management",
    description: "Create/manage contests with entry limits",
  },
  {
    id: 4,
    icon: require("../../../image/fantasysports/ad-img-four.webp"),
    title: "Revenue Tracking",
    description: "Detailed income reports",
  },
  {
    id: 5,
    icon: require("../../../image/fantasysports/ad-img-five.webp"),
    title: "Referral System",
    description: "Reward user referrals",
  },
  {
    id: 6,
    icon: require("../../../image/fantasysports/ad-img-six.webp"),
    title: "Content Management",
    description: "Secure deposits, withdrawals, transaction history",
  },
  {
    id: 7,
    icon: require("../../../image/fantasysports/ad-img-seven.webp"),
    title: "Analytics Dashboard",
    description: "User behavior, engagement, conversion",
  },
];

export const popularGames = [
  {
    id: 1,
    gameIcon: require("../../../image/fantasysports/football.webp"),
    gameName: "Football (Soccer)",
  },
  {
    id: 2,
    gameIcon: require("../../../image/fantasysports/basketball.webp"),
    gameName: "Basketball",
  },
  {
    id: 3,
    gameIcon: require("../../../image/fantasysports/baseball.webp"),
    gameName: "Baseball",
  },
  {
    id: 4,
    gameIcon: require("../../../image/fantasysports/kabadi.webp"),
    gameName: "Kabaddi",
  },
  {
    id: 5,
    gameIcon: require("../../../image/fantasysports/tennis.webp"),
    gameName: "Tennis",
  },
  {
    id: 6,
    gameIcon: require("../../../image/fantasysports/hockey.webp"),
    gameName: "Hockey",
  },
  {
    id: 7,
    gameIcon: require("../../../image/fantasysports/golf.webp"),
    gameName: "Golf",
  },
  {
    id: 8,
    gameIcon: require("../../../image/fantasysports/esports.webp"),
    gameName: "Esports",
  },
];

export const techTabs = [
  { id: "frontend", label: "Frontend" },
  { id: "backend", label: "Backend" },
  { id: "database", label: "Database" },
  { id: "api", label: "APIs" },
  { id: "cloud", label: "Cloud & Security" },
];

export const techTabsData = [
  {
    id: "frontend",
    label: "Frontend",
    data: [
      {
        id: 1,
        icon: require("../../../image/fantasysports/flutter.webp"),
        title: "Flutter",
      },
      {
        id: 2,
        icon: require("../../../image/fantasysports/re-native.webp"),
        title: "React Native",
      },
      {
        id: 3,
        icon: require("../../../image/fantasysports/swift.webp"),
        title: "Swift (iOS)",
      },
      {
        id: 4,
        icon: require("../../../image/fantasysports/kotlin.webp"),
        title: "Kotlin (Android)",
      },
    ],
  },
  {
    id: "backend",
    label: "Backend",
    data: [
      {
        id: 1,
        icon: require("../../../image/fantasysports/node.webp"),
        title: "Node.js",
      },
      {
        id: 2,
        icon: require("../../../image/fantasysports/laravel.webp"),
        title: "Laravel",
      },
      {
        id: 3,
        icon: require("../../../image/fantasysports/python.webp"),
        title: "Python",
      },
      {
        id: 4,
        icon: require("../../../image/fantasysports/java.webp"),
        title: "Java",
      },
    ],
  },
  {
    id: "database",
    label: "Database",
    data: [
      {
        id: 1,
        icon: require("../../../image/fantasysports/mongodb.webp"),
        title: "MongoDB",
      },
      {
        id: 2,
        icon: require("../../../image/fantasysports/mysql.webp"),
        title: "MySQL",
      },
      {
        id: 3,
        icon: require("../../../image/fantasysports/postgresql.webp"),
        title: "PostgreSQL",
      },
    ],
  },
  {
    id: "api",
    label: "APIs",
    data: [
      {
        id: 1,
        icon: require("../../../image/fantasysports/realtime.webp"),
        title: "Real-time sports data APIs",
      },
      {
        id: 2,
        icon: require("../../../image/fantasysports/payment.webp"),
        title: "Payment gateway APIs",
      },
      {
        id: 3,
        icon: require("../../../image/fantasysports/social.webp"),
        title: "Social media APIs",
      },
      {
        id: 4,
        icon: require("../../../image/fantasysports/push.webp"),
        title: "Push notification APIs",
      },
    ],
  },
  {
    id: "cloud",
    label: "Cloud & Security",
    data: [
      {
        id: 1,
        icon: require("../../../image/fantasysports/aws.webp"),
        title: "AWS",
      },
      {
        id: 2,
        icon: require("../../../image/fantasysports/firebase.webp"),
        title: "Firebase",
      },
      {
        id: 3,
        icon: require("../../../image/fantasysports/ssl.webp"),
        title: "SSL Encryption",
      },
      {
        id: 4,
        icon: require("../../../image/fantasysports/secure.webp"),
        title: "Secure Authentication",
      },
    ],
  },
];

export const fantasySteps = [
  {
    id: 1,
    image: require("../../../image/fantasysports/wk-img-one.webp"),
    title: "Requirement Analysis",
    description:
      "Understanding your goals, sports niche, features, and budget.",
    className: "hw_one",
  },
  {
    id: 2,
    image: require("../../../image/fantasysports/wk-img-two.webp"),
    title: "UI/UX Design",
    description: "Creating a user-friendly and attractive design.",
    className: "hw_two",
  },
  {
    id: 3,
    image: require("../../../image/fantasysports/wk-img-three.webp"),
    title: "Development",
    description: "Front-end and backend development using the latest tech.",
    className: "hw_three",
  },
  {
    id: 4,
    image: require("../../../image/fantasysports/wk-img-four.webp"),
    title: "API Integration",
    description: "Adding player stats, live scores and secure payments.",
    className: "hw_four",
  },
  {
    id: 5,
    image: require("../../../image/fantasysports/wk-img-five.webp"),
    title: "Testing",
    description: "Manual and automated testing for bugs and performance.",
    className: "hw_five",
  },
  {
    id: 6,
    image: require("../../../image/fantasysports/wk-img-six.webp"),
    title: "Deployment",
    description:
      "Launching the app on Web platforms, Android, or iOS platforms.",
    className: "hw_six",
  },
];

export const selectionCards = [
  {
    id: 1,
    image: require("../../../image/fantasysports/sl-img-one.webp"),
    title: "Experience & Portfolio",
    description:
      "Look for companies with experience in building fantasy apps. Ask for a portfolio and case studies.",
  },
  {
    id: 2,
    image: require("../../../image/fantasysports/sl-img-two.webp"),
    title: "Customization",
    description:
      "Choose a team that offers tailor-made solutions, not just clones.",
  },
  {
    id: 3,
    image: require("../../../image/fantasysports/sl-img-three.webp"),
    title: "Technology Stack",
    description:
      "Ensure the company uses the latest frameworks and secure coding practices.",
  },
  {
    id: 4,
    image: require("../../../image/fantasysports/sl-img-four.webp"),
    title: "Cost-Effective Packages",
    description:
      "Compare prices and services. Look for transparent pricing models.",
  },
  {
    id: 5,
    image: require("../../../image/fantasysports/sl-img-five.webp"),
    title: "Post-Launch Support",
    description:
      "Reliable companies offer updates, maintenance, and bug free support after launch.",
  },
  {
    id: 6,
    image: require("../../../image/fantasysports/sl-img-six.webp"),
    title: "Client Reviews",
    description: "Check testimonials on Clutch, GoodFirms, or Google Reviews.",
  },
];

export const costFactors = [
  {
    id: 1,
    image: require("../../../image/fantasysports/ct-img-one.webp"),
    text: "App complexity and features",
  },
  {
    id: 2,
    image: require("../../../image/fantasysports/ct-img-two.webp"),
    text: "Number of sports and matches",
  },
  {
    id: 3,
    image: require("../../../image/fantasysports/ct-img-three.webp"),
    text: "Type of contests",
  },
  {
    id: 4,
    image: require("../../../image/fantasysports/ct-img-four.webp"),
    text: "User interface design",
  },
  {
    id: 5,
    image: require("../../../image/fantasysports/ct-img-five.webp"),
    text: "Backend development",
  },
  {
    id: 6,
    image: require("../../../image/fantasysports/ct-img-six.webp"),
    text: "Real-time data integration",
  },
  {
    id: 7,
    image: require("../../../image/fantasysports/ct-img-seven.webp"),
    text: "Platforms (Android/iOS/Web)",
  },
];

export const appPricing = [
  {
    id: 1,
    price: "$5,000 – $10,000",
    label: "Basic App",
  },
  {
    id: 2,
    price: "$10,000 – $20,000+",
    label: "Custom App with Premium Features",
  },
  {
    id: 3,
    price: "Starting from $8,000",
    label: "MVP Development",
  },
];

export const whyTemplate = [
  {
    id: 1,
    img: require("../../../image/fantasysports/wt-img-one.webp"),
    title: "Pre-built solution",
  },
  {
    id: 2,
    img: require("../../../image/fantasysports/wt-img-two.webp"),
    title: "Quick launch",
  },
  {
    id: 3,
    img: require("../../../image/fantasysports/wt-img-three.webp"),
    title: "Cost-effective",
  },
  {
    id: 4,
    img: require("../../../image/fantasysports/wt-img-four.webp"),
    title: "Limited customization",
  },
];

export const hireCards = [
  {
    id: 1,
    img: require("../../../image/fantasysports/hr-img-one.webp"),
    title: "Technical expertise",
  },
  {
    id: 2,
    img: require("../../../image/fantasysports/hr-img-two.webp"),
    title: "End-to-end service",
  },
  {
    id: 3,
    img: require("../../../image/fantasysports/hr-img-three.webp"),
    title: "Scalable solutions",
  },
  {
    id: 4,
    img: require("../../../image/fantasysports/hr-img-four.webp"),
    title: "Sports analytics integration",
  },
  {
    id: 5,
    img: require("../../../image/fantasysports/hr-img-five.webp"),
    title: "Legal compliance guidance",
  },
  {
    id: 6,
    img: require("../../../image/fantasysports/hr-img-six.webp"),
    title: "Quality assurance",
  },
];

export const monetizationData = [
  {
    id: 1,
    img: require("../../../image/fantasysports/mn-img-one.webp"),
    title: "Entry Fees & Winnings",
  },
  {
    id: 2,
    img: require("../../../image/fantasysports/mn-img-two.webp"),
    title: "Advertisements (Banners, Videos, Sponsors)",
  },
  {
    id: 3,
    img: require("../../../image/fantasysports/mn-img-three.webp"),
    title: "Premium Features",
  },
  {
    id: 4,
    img: require("../../../image/fantasysports/mn-img-four.webp"),
    title: "Affiliate Marketing",
  },
  {
    id: 5,
    img: require("../../../image/fantasysports/mn-img-five.webp"),
    title: "In-app Purchases",
  },
  {
    id: 6,
    img: require("../../../image/fantasysports/mn-img-six.webp"),
    title: "Brand Collaborations",
  },
];
